export default __webpack_public_path__ + "static/media/selectclient.cca69636.svg";